import { useNavigate } from 'react-router-dom';

import { ContentNugget } from '@backrs_ui/common-ui';

import { handlePanelNuggetClick } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { NuggetSection } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/NuggetSection';

import { useAgentContext } from './ResourcesSection.agentContext';

type ResourcesSectionProps = Readonly<{
  resources: ContentNugget[];
  isLoading: boolean;
}>;

export const ResourcesSection = ({ resources, isLoading }: ResourcesSectionProps) => {
  useAgentContext(resources);
  const navigate = useNavigate();

  const handleNuggetClick = (nugget: ContentNugget) => {
    handlePanelNuggetClick(nugget, navigate);
  };

  return (
    <NuggetSection nuggets={resources} onNuggetClick={handleNuggetClick} loading={isLoading} />
  );
};
